module.exports = __webpack_public_path__ + "static/media/new message.e5a346cd.svg";